"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFileInState = exports.flatten = exports.decryptFile = exports.encryptFile = void 0;
var browser = __importStar(require("./browserApi"));
var node = __importStar(require("./nodeApi"));
/**
 * Encrypt a file.
 * @param file in NodeJS: the file path. In a browser: a File object.
 * @param encryptionKey symmetric encryption key.
 * @returns a 'fs.readStream' in node and a 'File' in a browser.
 */
var encryptFile = function (file, encryptionKey) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (typeof file === 'string') {
            return [2 /*return*/, node.encryptFile(file, encryptionKey)];
        }
        return [2 /*return*/, browser.encryptFile(file, encryptionKey)];
    });
}); };
exports.encryptFile = encryptFile;
/**
 * Decrypt a file.
 * @param file in NodeJS: the file path. In a browser: a File object.
 * @param decryptionKey symmetric decryption key.
 * @returns a 'fs.readStream' in node and a 'File' in a browser.
 */
var decryptFile = function (file, decryptionKey) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (Buffer.isBuffer(file)) {
            return [2 /*return*/, node.decryptFile(file, decryptionKey)];
        }
        return [2 /*return*/, browser.decryptFile(file, decryptionKey)];
    });
}); };
exports.decryptFile = decryptFile;
// flatten an object
// from { a: { b: { c: 1 } } }
// to { a.b.c: 1 }
var flatten = function (obj, path) {
    var _a;
    if (path === void 0) { path = ''; }
    if (!(obj instanceof Object))
        return _a = {}, _a[path.replace(/\.$/g, '')] = obj, _a;
    return Object.keys(obj).reduce(function (output, key) {
        return obj instanceof Array
            ? __assign(__assign({}, output), (0, exports.flatten)(obj[key], "".concat(path, "[").concat(key, "]."))) : __assign(__assign({}, output), (0, exports.flatten)(obj[key], "".concat(path).concat(key, ".")));
    }, {});
};
exports.flatten = flatten;
var findFileInState = function (state, digest) {
    var flattenState = (0, exports.flatten)(state);
    var pathToFile = Object.keys(flattenState).find(function (key) { return flattenState[key] === digest; });
    if (!pathToFile) {
        throw new Error('File not found in flattened state');
    }
    var finalPath = pathToFile.replace('.digest', '').replace('.id', '');
    var finalFile = {};
    Object.keys(flattenState)
        .filter(function (i) { return i.includes(finalPath); })
        .forEach(function (k) {
        if (flattenState[k] === null || flattenState[k] === undefined) {
            throw new Error("Missing necessary file information in state: ".concat(k));
        }
        finalFile[k.split('.').slice(-1)[0]] = flattenState[k];
    });
    return {
        key: finalFile['key'],
        name: finalFile['name'],
        size: finalFile['size'],
        digest: finalFile['digest'],
        mimetype: finalFile['mimetype'],
    };
};
exports.findFileInState = findFileInState;
//# sourceMappingURL=helpers.js.map